import {
	type PropsWithChildren,
	createContext,
	useContext,
	useMemo,
} from 'react';
import { DeviceType, getDeviceType } from '../utils/getDeviceType';
import { type Breakpoints, useBreakpoint } from './useBreakpoint';

// Undefined - для обратной совместимости.
const DeviceTypeContext = createContext<undefined | DeviceType>(undefined);

/**
 * Хук возвращает текущий тип устройства.
 */
export function useDeviceType(): DeviceType {
	const deviceTypeFromContext = useContext(DeviceTypeContext);

	// Только для обратной совместимости. В дальнейшем необходимо убрать.
	const componentDeviceType = useDeviceTypeBaseOnMediaQuery();

	if (!deviceTypeFromContext) {
		return componentDeviceType;
	}

	return deviceTypeFromContext;
}

/**
 * Провайдер передающий всем дочерним компонентам текущий тип устройства.
 *
 * Есть возможность переопределить тип устройства.
 */
export const DeviceTypeProvider = (props: PropsWithChildren) => {
	const currentDeviceType = useDeviceTypeBaseOnMediaQuery();

	return (
		<DeviceTypeContext.Provider value={currentDeviceType}>
			{props.children}
		</DeviceTypeContext.Provider>
	);
};

function useDeviceTypeBaseOnMediaQuery() {
	const breakpoint = useBreakpoint();
	return useMemo(() => getDeviseType(breakpoint), [breakpoint]);
}

function getDeviseType(breakpoint: Breakpoints) {
	const isTablet = breakpoint.tablet;
	const isMobile = breakpoint.mobile;
	const deviceType = getDeviceType();
	if ((isTablet || isMobile) && deviceType === 'mobile') {
		if (isTablet) return DeviceType.tablet;
		if (isMobile) return DeviceType.mobile;
	}
	return DeviceType.desktop;
}
